<!-- <div class="flex flex-col w-full relative"> -->
  <div class="flex flex-col   w-full max-w-[400px] mx-auto overflow-hidden"> 
  <p class="font-bold 2xl:mb-2 grad-main-color text-transparent bg-clip-text self-start text-nowrap">{{ lable }}</p>
  <canvas 
    baseChart
    [type]="'doughnut'"
    class="  h-[10vh]  max-h-[120px] w-full"
    [datasets]="pieChartDatasets"
    [options]="pieChartOptions"
  >
  </canvas>
</div> 
